import React, { useCallback } from 'react';

import type { FormStepId } from 'shared/config/formStepId';
import { sendEventOnEsiaBannerAuthSuccess, sendEventOnEsiaButtonClick } from 'shared/lib/sendGAEvents';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import { AuthenticationEsia, useIsShowAuthenticationEsia } from 'features/AuthenticationEsia';
import { EsiaConsentBanner, useShouldShowEsiaConsentBanner } from 'features/EsiaConsentBanner';

type EsiaProps = {
  formId: FormStepId;
  analyticsOverrides?: TFormAnalyticsEventsOverrides;
};

export const Esia = ({ formId, analyticsOverrides }: EsiaProps) => {
  const checkIsShowEsiaLoginBlock = useIsShowAuthenticationEsia();
  const isShowEsiaBlock = checkIsShowEsiaLoginBlock(formId);
  const shouldShowConsentBanner = useShouldShowEsiaConsentBanner(formId);

  const onEsiaClick = useCallback(() => {
    sendEventOnEsiaButtonClick(analyticsOverrides);
  }, [analyticsOverrides]);

  const onEsiaSuccess = useCallback(() => {
    sendEventOnEsiaBannerAuthSuccess(analyticsOverrides);
  }, [analyticsOverrides]);

  if (shouldShowConsentBanner) {
    return <EsiaConsentBanner />;
  }

  if (isShowEsiaBlock) {
    return (
      <AuthenticationEsia
        step={formId}
        onEsiaButtonClick={onEsiaClick}
        onEsiaSuccess={onEsiaSuccess}
      />
    );
  }

  return null;
};
